module.exports = __webpack_public_path__ + "static/media/magzine3.9b86bf82.jpg";